import Box from '@mui/material/Box';
import { memo } from 'react';

const SectionDivider = ({ variant = 'line', color = 'divider', mt = 6, mb = 6 }) => {
  if (variant === 'wave') {
    return (
      <Box aria-hidden sx={{ my: { xs: mt, md: mt }, mb: { xs: mb, md: mb } }}>
        <Box
          sx={{
            height: 24,
            background: (t) => `linear-gradient(90deg, transparent, ${t.palette[color] || t.palette.divider}, transparent)`,
            maskImage:
              'radial-gradient(12px 12px at 12px 12px, black 98%, transparent), radial-gradient(12px 12px at calc(100% - 12px) 12px, black 98%, transparent)',
            opacity: 0.35,
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      aria-hidden
      sx={{
        my: { xs: mt, md: mt },
        mb: { xs: mb, md: mb },
        height: 1,
        background: (t) => `linear-gradient(90deg, transparent, ${t.palette[color] || t.palette.divider}, transparent)`,
        opacity: 0.35,
      }}
    />
  );
};

export default memo(SectionDivider);